"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(consumerTheme) {
  return {
    v: '5.5.7',
    meta: {
      g: 'LottieFiles AE 0.1.21',
      a: '',
      k: '',
      d: '',
      tc: ''
    },
    fr: 60,
    ip: 0,
    op: 90,
    w: 1080,
    h: 1080,
    nm: 'pre-loader - cropped',
    ddd: 0,
    assets: [],
    layers: [{
      ddd: 0,
      ind: 1,
      ty: 3,
      nm: 'Null',
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [530, 695, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [50, 50, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [249, 249, 100],
          ix: 6
        }
      },
      ao: 0,
      ip: 0,
      op: 4184.18418418418,
      st: -20.02002002002,
      bm: 0
    }, {
      ddd: 0,
      ind: 2,
      ty: 4,
      nm: 'Pocket',
      parent: 1,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 99,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [69.749, 40.836, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [542.577, 97.337, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [123.457, 123.457, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 1,
            k: [{
              i: {
                x: 0.5,
                y: 1
              },
              o: {
                x: 0.5,
                y: 0
              },
              t: 0,
              s: [{
                i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                v: [[278.791, -97.228], [302.634, 96.946], [535.974, 96.946], [512.126, -97.228]],
                c: true
              }]
            }, {
              i: {
                x: 0.5,
                y: 1
              },
              o: {
                x: 0.5,
                y: 0
              },
              t: 23,
              s: [{
                i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                v: [[484.468, -97.1], [508.311, 97.074], [535.974, 96.946], [512.126, -97.228]],
                c: true
              }]
            }, {
              i: {
                x: 0.5,
                y: 1
              },
              o: {
                x: 0.5,
                y: 0
              },
              t: 45,
              s: [{
                i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                v: [[278.791, -97.228], [302.634, 96.946], [535.974, 96.946], [512.126, -97.228]],
                c: true
              }]
            }, {
              i: {
                x: 0.5,
                y: 1
              },
              o: {
                x: 0.5,
                y: 0
              },
              t: 68,
              s: [{
                i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                v: [[278.791, -97.228], [302.634, 96.946], [331.092, 97.074], [307.244, -97.1]],
                c: true
              }]
            }, {
              i: {
                x: 0.233,
                y: 1
              },
              o: {
                x: 0.5,
                y: 0
              },
              t: 90,
              s: [{
                i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                v: [[278.791, -97.228], [302.634, 96.946], [535.974, 96.946], [512.126, -97.228]],
                c: true
              }]
            }, {
              i: {
                x: 0.833,
                y: 0.833
              },
              o: {
                x: 0.753,
                y: 0
              },
              t: 135,
              s: [{
                i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                v: [[278.791, -97.228], [302.634, 96.946], [535.974, 96.946], [512.126, -97.228]],
                c: true
              }]
            }, {
              i: {
                x: 0.833,
                y: 0.833
              },
              o: {
                x: 1,
                y: 1
              },
              t: 150,
              s: [{
                i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                v: [[278.791, -97.228], [302.634, 96.946], [535.974, 96.946], [512.126, -97.228]],
                c: true
              }]
            }, {
              t: 178,
              s: [{
                i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                v: [[232.61, -289.11], [304.651, 287.434], [596.526, 287.241], [524.479, -289.303]],
                c: true
              }]
            }],
            ix: 2
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false
        }, {
          ty: 'fl',
          c: {
            a: 0,
            k: consumerTheme ? [0.666666666667, 0.560784313725, 1, 1] : [0.43137254901960786, 0.7843137254901961, 1, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          bm: 0,
          nm: 'Fill 1',
          mn: 'ADBE Vector Graphic - Fill',
          hd: false
        }, {
          ty: 'tr',
          p: {
            a: 0,
            k: [542.819, 97.337],
            ix: 2
          },
          a: {
            a: 0,
            k: [413.977, 0],
            ix: 1
          },
          s: {
            a: 1,
            k: [{
              i: {
                x: [0.833, 0.833],
                y: [0.833, 0.833]
              },
              o: {
                x: [1, 1],
                y: [0, 0]
              },
              t: 150,
              s: [100, 100]
            }, {
              t: 178,
              s: [814, 814]
            }],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: 'Transform'
        }],
        nm: 'Group 1',
        np: 2,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: 'ADBE Vector Group',
        hd: false
      }],
      ip: 0,
      op: 180.18018018018,
      st: 0,
      bm: 0
    }, {
      ddd: 0,
      ind: 3,
      ty: 4,
      nm: 'Dot 4',
      parent: 1,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 1,
          k: [{
            i: {
              x: 0.265,
              y: 1
            },
            o: {
              x: 0.732,
              y: 0
            },
            t: 0,
            s: [-43.332, -141.206, 0],
            to: [29.575, 0, 0],
            ti: [0, 0, 0]
          }, {
            i: {
              x: 0.263,
              y: 1
            },
            o: {
              x: 0.739,
              y: 0
            },
            t: 45,
            s: [134.119, -141.206, 0],
            to: [0, 0, 0],
            ti: [29.575, 0, 0]
          }, {
            t: 90,
            s: [-43.332, -141.206, 0]
          }],
          ix: 2
        },
        a: {
          a: 0,
          k: [39.798, 38.434, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [123.457, 123.457, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[-15.269, -13.585], [-11.901, 13.585], [15.269, 13.585], [11.901, -13.586]],
              o: [[15.269, 13.585], [11.902, -13.585], [-15.269, -13.586], [-11.902, 13.585]],
              v: [[-21.55, 24.598], [27.646, 24.598], [21.55, -24.598], [-27.646, -24.598]],
              c: true
            },
            ix: 2
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false
        }, {
          ty: 'fl',
          c: {
            a: 0,
            k: [0.105882352941, 0.074509803922, 0.137254901961, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          bm: 0,
          nm: 'Fill 1',
          mn: 'ADBE Vector Graphic - Fill',
          hd: false
        }, {
          ty: 'tr',
          p: {
            a: 0,
            k: [101.697, 73.505],
            ix: 2
          },
          a: {
            a: 0,
            k: [61.899, 35.071],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: 'Transform'
        }],
        nm: 'Group 1',
        np: 2,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: 'ADBE Vector Group',
        hd: false
      }],
      ip: 0,
      op: 150,
      st: 0,
      bm: 0
    }],
    markers: []
  };
};

exports["default"] = _default;